module.exports = __webpack_public_path__ + "static/TruenoUltLt-689da0f5655c265d1fdfa39b21fa1912.woff2";